import { ReducerAction, ReducerHandler, ChatList } from '../../Types';
import { StoreChatlist } from '../../Types/StoreTypes';
import { SET_CHATLIST_OPEN, SET_CHATLIST_OPEN_HOVER, SET_CHATLIST } from '../Actions/chatlistActions';

const initialState = {
    chatlist: [] as ChatList[],
    chatlistOpen: !localStorage.getItem('chatlistOpen') || localStorage.getItem('chatlistOpen') === 'true',
    chatlistOpenHover: false,
} as StoreChatlist;

const chatlistReducerMap: Record<string, ReducerHandler<StoreChatlist>> = {
    [SET_CHATLIST]: (state, action) => ({ ...state, chatlist: action.payload }),
    [SET_CHATLIST_OPEN]: (state, action) => ({ ...state, chatlistOpen: action.payload }),
    [SET_CHATLIST_OPEN_HOVER]: (state, action) => ({ ...state, chatlistOpenHover: action.payload }),
};

function chatlistReducer(state = initialState, action: ReducerAction): StoreChatlist {
    const handler = chatlistReducerMap[action.type];
    return handler ? handler(state, action) : state;
}

export default chatlistReducer;
